import {
  animate,
  motion,
  useMotionValue,
  useMotionValueEvent,
  useScroll,
} from "framer-motion";

import { random } from "../../util/random";
import { useEffect } from "react";

interface Props {
  constraintRef?: any;
  minX: number;
  maxX: number;
  maxXVel: () => number;
  minY: number;
  maxY: number;
  xScroll?: number;
  yScroll?: number;
  rotate?: number;
  calculateYVal: () => number | undefined;
  children: any;
}

export default function Draggable({
  children,
  constraintRef,
  minX,
  maxX,
  maxXVel,
  minY,
  maxY,
  xScroll,
  yScroll,
  rotate,
  calculateYVal,
}: Props) {
  const scrollX = xScroll || 0;
  const scrollYCapture = yScroll || 0.3;

  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const cx = useMotionValue(0);
  const cy = useMotionValue(0);
  const opacity = useMotionValue(0);
  const { scrollY } = useScroll();

  useEffect(() => {
    x.set(window.innerWidth * random(minX, maxX));
    y.set(window.innerHeight * random(minY, maxY));

    animate(x, 0, {
      type: "inertia",
      velocity: maxXVel() * (Math.random() - 0.5),
    });
    animate(y, 0, {
      type: "inertia",
      velocity: calculateYVal(),
    });

    animate(opacity, 1, {
      duration: 1,
    });
  }, [maxX, maxY, minX, minY]);

  useMotionValueEvent(x, "change", (latest) => {
    cx.set(latest);
  });

  useMotionValueEvent(y, "change", (latest) => {
    cy.set(latest);
  });

  useMotionValueEvent(scrollY, "change", (latest) => {
    animate(cx, x.get() - scrollX * latest, {
      ease: "easeOut",
      duration: 0.1,
    });
    animate(cy, y.get() - scrollYCapture * latest, {
      ease: "easeOut",
      duration: 0.1,
    });
  });

  return (
    <motion.div
      drag
      // TODO: open up constraints
      dragConstraints={constraintRef}
      className="absolute cursor-pointer mix-blend-multiply inline"
      style={{ x: cx, y: cy, opacity, rotate }}
      whileHover={{
        scale: 1.1,
        transition: { duration: 0.3 },
      }}
    >
      {children}
    </motion.div>
  );
}
